import React, { useState } from 'react'
import PropTypes from 'prop-types';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import './styles.css';
import { useEffect } from 'react';
import { validationMessages, validationsTypeEnum } from './utils/appInputenum';
import { ToastContainer, toast } from 'react-toastify';
import { fileUploadbtnToastMessages } from './utils/appInputenum';
import { uploadFileTypes } from './utils/appInputenum';

const FileUploadBtn = (props) => {

    //#region Props
    const {
        name,
        label,
        onChange,
        disabled,
        defaultFile,
        fileType,
        clearFile,
        required,
        checkIfValid,
        setcheckIfValid,
        maxSize,
        validationType,
        readOnly,
        validationMessage,
        checknoofValidFields,
        imgClassName,
        parentError } = props;

    //#region variables
    const [file, setFile] = useState(null);
    const [error, setError] = useState(false);
    const [isDragActive, setIsDragActive] = useState(false);
    const fileInputRef = React.createRef();

    //#region change events
    const handleChange = (ev) => {
        const { name, files } = ev.target;
        const file = files[0];
        const maxFileSize = maxSize ? maxSize * 1024 * 1024 : 2 * 1024 * 1024; // Default to 2MB
        const allowedImageTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/svg+xml'];

        // Reset input if no file is selected
        if (!file) {
            resetInput();
            return;
        }

        // PDF File Validation
        if (fileType === uploadFileTypes.PDF && file.type !== 'application/pdf') {
            toast.warning(fileUploadbtnToastMessages.ONLY_PDF_FILE_ALLOW, {
                position: "bottom-right",
                theme: "colored",
            });
            setError(true);
            resetInput();
            return;
        }

        // Image File Validation
        if (fileType === uploadFileTypes.IMAGE) {
            if (!allowedImageTypes.includes(file.type)) {
                toast.warning(fileUploadbtnToastMessages.ONLY_JPG_JPEG_PNG, {
                    position: "bottom-right",
                    theme: "colored",
                });
                resetInput();
                return;
            }

            if (file.size > maxFileSize) {
                toast.warning(fileUploadbtnToastMessages.SHOULD_BE_2MB, {
                    position: "bottom-right",
                    theme: "colored",
                });
                resetInput();
                return;
            }
        }

        // CSV File Validation
        if (fileType === uploadFileTypes.CSV) {
            const isCSV = file.type === 'text/csv' || file.type.includes('excel') || file.type.includes('spreadsheetml');
            if (!isCSV) {
                toast.warning(fileUploadbtnToastMessages.ONLY_CSV_FILE_ALLOW, {
                    position: "bottom-right",
                    theme: "colored",
                });
                setError(true);
                resetInput();
                return;
            }

            if (file.size > maxFileSize) {
                const maxFileSizeInMB = maxFileSize / (1024 * 1024); // Convert maxFileSize to MB
                toast.warning(`The file size should not exceed ${maxFileSizeInMB}MB.`, {
                    position: "bottom-right",
                    theme: "colored",
                });
                setError(true);
                resetInput();
                return;
            }
        }

        if (fileType === uploadFileTypes.Documents) {
            // Documents : '.doc, .docx, .xls, .xlsx, .pdf, .txt, .ppt, .pptx',
            const isAllowedFile = [
                "application/msword",                   // .doc
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
               /*  "application/vnd.ms-excel",              // .xls
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx */
                "application/pdf",                        // .pdf
                /* "text/plain",                             // .txt */
                "application/vnd.ms-powerpoint",         // .ppt
                "application/vnd.openxmlformats-officedocument.presentationml.presentation" // .pptx
            ];

            const isCSV = isAllowedFile.includes(file.type);
            if (!isCSV) {
                toast.warning(fileUploadbtnToastMessages.ONLY_ALLOW_DOCUMENTS, {
                    position: "bottom-right",
                    theme: "colored",
                });
                setError(true);
                resetInput();
                return;
            }

            if (file.size > maxFileSize) {
                const maxFileSizeInMB = maxFileSize / (1024 * 1024); // Convert maxFileSize to MB
                toast.warning(`The file size should not exceed ${maxFileSizeInMB}MB.`, {
                    position: "bottom-right",
                    theme: "colored",
                });
                setError(true);
                resetInput();
                return;
            }
        }

        if (fileType === uploadFileTypes.PDF_EXCEL) {
            const allowedTypes = ['application/pdf', 'text/csv', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'excel', 'spreadsheetml'];
            if (!allowedTypes.includes(file.type)) {
                toast.warning(fileUploadbtnToastMessages.ONLY_PDF_EXCEL_FILE_ALLOW, {
                    position: "bottom-right",
                    theme: "colored",
                });
                setError(true);
                resetInput();
                return;
            }

            if (file.size > maxFileSize) {
                const maxFileSizeInMB = maxFileSize / (1024 * 1024); // Convert maxFileSize to MB
                toast.warning(`The file size should not exceed ${maxFileSizeInMB}MB.`, {
                    position: "bottom-right",
                    theme: "colored",
                });
                setError(true);
                resetInput();
                return;
            }
        }

        if (fileType === uploadFileTypes.PDF) {
            const allowedTypes = ['application/pdf'];
            if (!allowedTypes.includes(file.type)) {
                toast.warning(fileUploadbtnToastMessages.ONLY_PDF_FILE_ALLOW, {
                    position: "bottom-right",
                    theme: "colored",
                });
                setError(true);
                resetInput();
                return;
            }

            if (file.size > maxFileSize) {
                const maxFileSizeInMB = maxFileSize / (1024 * 1024); // Convert maxFileSize to MB
                toast.warning(`The file size should not exceed ${maxFileSizeInMB}MB.`, {
                    position: "bottom-right",
                    theme: "colored",
                });
                setError(true);
                resetInput();
                return;
            }
        }

        // Valid File Handling
        setFile(fileType === uploadFileTypes.IMAGE ? URL.createObjectURL(file) : file);
        onChange(name, file);
    };

    // Helper function to reset file input
    const resetInput = () => {
        if (fileInputRef.current) {
            fileInputRef.current.value = null; // Clear the input value
        }
        setFile(null); // Also reset the file state
    };


    //#region click events
    const handleClearFile = () => {
        setFile(null);
        onChange(name, null);
    }

    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragActive(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragActive(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragActive(false);
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            // Simulate file input change event
            const fileList = e.dataTransfer.files;
            const fakeEvent = {
                target: {
                    name,
                    files: fileList
                }
            };
            handleChange(fakeEvent);
        }
    };

    //#region Validations useEffect
    useEffect(() => {
        if (checkIfValid) {
            const isValid = file === '' || file === null ? false : true;
            if (isValid) {
                checknoofValidFields(isValid, name, file);
                setcheckIfValid(false);
            } else {
                setError(!isValid);
                setcheckIfValid(false);
            }
        }
    }, [checkIfValid])

    useEffect(() => {
        if (clearFile || disabled) {
            setFile(null);
        }
    }, [clearFile, disabled])

    useEffect(() => {
        setError(parentError);
    }, [parentError])

    useEffect(() => {
        if (defaultFile && defaultFile !== '') {
            if (fileType === uploadFileTypes.IMAGE) {
                if (typeof defaultFile === 'string') {
                    setFile(defaultFile);
                } else if (defaultFile instanceof Blob || defaultFile instanceof File) {
                    const fileURL = URL.createObjectURL(defaultFile);
                    setFile(fileURL);
                } else {
                    setFile(null);
                }
            } else {
                setFile(defaultFile);
            }
        }
        else{
            if(defaultFile === null || defaultFile === ''){
                setFile(null);
            }
        }
    }, [defaultFile, fileType]);

    //#region render accept type
    const renderAcceptType = () => {
        switch (fileType) {
            case uploadFileTypes.PDF:
                return uploadFileTypes.PDF_TYPES;
            case uploadFileTypes.IMAGE:
                return uploadFileTypes.IMAGE_TYPES;
            default:
                return '';
        }
    }

    //#region render File Preview
    const renderFilePreview = () => {
        if (file) {
            return (
                <div className='fileUploadBtn previewWrapper'>
                    {
                        fileType === uploadFileTypes.IMAGE ?
                            <img
                                src={file}
                                alt="Preview"
                                className={imgClassName && imgClassName !== "" ? imgClassName : 'file-preview'}
                            /> :
                            <div className='upload-preview'>{file?.name || file}</div>
                    }
                    {!readOnly && <CloseOutlinedIcon onClick={handleClearFile} />}
                </div>
            )
        }
    }

    //region render upload file button
    const renderFilebutton = () => {
        const classses = disabled ? (error ? 'filebtn-disabled-error' : 'filebtn-disabled') : (error ? 'fileUploadBtn file-error' : 'fileUploadBtn');
        return (
            <div className='display-column'>
                <div className={classses}>
                    <CloudUploadIcon />
                    <input
                        type="file"
                        id={name}
                        name={name}
                        onChange={handleChange}
                        disabled={disabled}
                        required={required}
                        ref={fileInputRef}
                        accept={renderAcceptType()}
                        hidden />
                    <label htmlFor={name}>{label}</label>
                    <br />
                </div>
                {error && <span className='errorMessage'>{
                    validationMessage
                }</span>}
            </div>
        )
    };

    //#region end
    return (
        <>
            <div style={{ width: '100%'}} className='display-center'>
                <div style={{ width: '100%'}} className='height-230 display-center child-margin-10 upload-document-card'
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    onDrop={handleDrop}>
                <div className='child-margin-10'>
                    <img src='/icons/upload.svg' alt='' className='display-center margin-left-60' style={{ width: '100px',height: '100px' }} />
                    <span className='font-color-gray'>
                    Drop your pitch deck file here or
                    </span>
                </div>
                <div>
                    {file ? renderFilePreview() : renderFilebutton()}
                </div>
                </div>
            </div>
        </>
    )
}

FileUploadBtn.propTypes = {
    label: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    defaultFile: PropTypes.string,
    clearFile: PropTypes.bool,
    fileType: PropTypes.string,
    required: PropTypes.bool,
    helperText: PropTypes.string,
}

FileUploadBtn.defaultProps = {
    label: 'Upload Document',
    name: 'file',
    disabled: false,
    defaultFile: '',
    clearFile: false,
    fileType: uploadFileTypes.ANY,
    required: false,
    helperText: '',
}


export default FileUploadBtn